import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchActionsAudit(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/audits', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
